import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { GoldButton } from "./ui-kit";
import { motion, AnimatePresence } from "framer-motion";

const LINKS = [
  { to: "/prestations", label: "Prestations" },
  { to: "/services-partenaires", label: "Partenaires" },
  { to: "/galerie", label: "Galerie" },
  { to: "/a-propos", label: "À propos" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-500 ${
        scrolled || open ? "bg-background/90 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-20 flex items-center justify-between">
        <Link to="/" data-testid="logo-link" className="flex items-center gap-3">
          <img src="/logo-kmr.jpg" alt="KMR Event" className="h-11 w-auto rounded-md object-cover" />
        </Link>

        <div className="hidden lg:flex items-center gap-8">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.slice(1)}`}
              className={`text-sm tracking-wide transition-colors duration-300 hover:text-gold ${
                loc.pathname === l.to ? "text-gold" : "text-foreground/80"
              }`}
            >
              {l.label}
            </Link>
          ))}
        </div>

        <div className="hidden lg:block">
          <GoldButton to="/devis" data-testid="nav-devis-btn">Demander un devis</GoldButton>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((o) => !o)}
          className="lg:hidden text-foreground p-2"
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden overflow-hidden bg-background/95 backdrop-blur-xl border-b border-white/10"
            data-testid="mobile-menu"
          >
            <div className="px-6 py-6 flex flex-col gap-1">
              {LINKS.map((l) => (
                <Link key={l.to} to={l.to} data-testid={`mnav-${l.to.slice(1)}`} className="py-3 text-lg text-foreground/90 hover:text-gold border-b border-white/5">
                  {l.label}
                </Link>
              ))}
              <GoldButton to="/devis" className="mt-5 w-full" data-testid="mnav-devis-btn">Demander un devis</GoldButton>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
